__turbopack_context__.v({
  "blueBackground": "GridRow-module-scss-module__7QGZNa__blueBackground",
  "buttonWrapper": "GridRow-module-scss-module__7QGZNa__buttonWrapper",
  "capitalize": "GridRow-module-scss-module__7QGZNa__capitalize",
  "column": "GridRow-module-scss-module__7QGZNa__column",
  "copy": "GridRow-module-scss-module__7QGZNa__copy",
  "countUpHeadline": "GridRow-module-scss-module__7QGZNa__countUpHeadline",
  "creamIcon": "GridRow-module-scss-module__7QGZNa__creamIcon",
  "eyebrow": "GridRow-module-scss-module__7QGZNa__eyebrow",
  "gridRow": "GridRow-module-scss-module__7QGZNa__gridRow",
  "gridRowReversed": "GridRow-module-scss-module__7QGZNa__gridRowReversed",
  "headline": "GridRow-module-scss-module__7QGZNa__headline",
  "icon": "GridRow-module-scss-module__7QGZNa__icon",
  "iconWrapper": "GridRow-module-scss-module__7QGZNa__iconWrapper",
  "image": "GridRow-module-scss-module__7QGZNa__image",
  "listHeadline": "GridRow-module-scss-module__7QGZNa__listHeadline",
  "listItem": "GridRow-module-scss-module__7QGZNa__listItem",
  "lockup": "GridRow-module-scss-module__7QGZNa__lockup",
  "people": "GridRow-module-scss-module__7QGZNa__people",
  "richTextH5": "GridRow-module-scss-module__7QGZNa__richTextH5",
  "testimonialCta": "GridRow-module-scss-module__7QGZNa__testimonialCta",
  "themeBlueBackground": "GridRow-module-scss-module__7QGZNa__themeBlueBackground",
  "themeCreamBackground": "GridRow-module-scss-module__7QGZNa__themeCreamBackground",
});
